import MultiDigitInput from '../shared/MultiDigitInput';
import NextButton from '../shared/NextButton';
import React from 'react';
import './VerificationCode.scss';

function VerificationCode({ callback, cancelCallback, resendCallback, disabled }) {
    const [verificationCode, setVerificationCode] = React.useState('');

    const firstDigitRef = React.useRef();

    const handleSubmit = (e) => {
        e.preventDefault();
        callback(verificationCode);
    };

    const resendClick = async () => {
        await resendCallback?.();
        firstDigitRef.current?.focus?.();
    };

    return (
        <div id="form-login-verification-code">
            <div role="main">
                <form onSubmit={handleSubmit}>
                    <h2>Enter verification code</h2>
                    {/*
                        TODO toggle delivery location
                            */}
                    <p>We have sent a verification code to your mobile phone. Enter it below to continue to log in.</p>
                    <MultiDigitInput
                        autofocus={true}
                        digits="6"
                        value={verificationCode}
                        onChange={setVerificationCode}
                        label="Verification Code"
                        disabled={disabled}
                        ref={firstDigitRef}
                    />
                    <NextButton
                        action={handleSubmit}
                        disabled={disabled || verificationCode.length < 6}
                    >
                        Verify and Log In
                    </NextButton>
                    <div id="no-receive">
                        Didn't receive a code?{' '}
                        <button
                            type="button"
                            className="button-link"
                            onClick={resendClick}
                        >
                            Resend code
                        </button>
                    </div>
                </form>
            </div>
            <button
                type="button"
                className="button-link"
                onClick={cancelCallback}
            >
                Restart login process
            </button>
        </div>
    );
}

export default VerificationCode;
